// extracted by mini-css-extract-plugin
export default {"table":"JobPositionAddPermissions-JobPositionAddPermissions__table--lwOL_"};